export const MESSAGE_SEAT = 0;
export const FREE_TEXT_TYPE = 4;

export const isFreeText = (seat?: number, type?: number) =>
  (seat ?? MESSAGE_SEAT) === MESSAGE_SEAT &&
  (type ?? FREE_TEXT_TYPE) === FREE_TEXT_TYPE;

export const getModifierName = (
  seat: number | undefined,
  value: string | undefined,
  type: number | undefined,
  labelMessage: string,
) => (isFreeText(seat, type) ? `${labelMessage}: ${value ?? ''}` : value ?? '');

export const toNum = (val: unknown): number | null => {
  const n =
    typeof val === 'string'
      ? Number(val.trim())
      : typeof val === 'number'
      ? val
      : NaN;
  return Number.isFinite(n) ? n : null;
};
